import IMessage from '../IMessage';
import { SynchronizerConfig } from '../../../Synchronization/ISynchronizer';

export enum SyncEngine {
	SyncServer = 'sync-server',
	P2PLocal = 'p2p-local',
	/** @deprecated use P2PLocal */
	Udp = 'udp',
}

interface ISyncConnectMessage extends IMessage {
	engine?: SyncEngine;
	serverUri?: string;
	config?: SynchronizerConfig;
}

export default ISyncConnectMessage;
